module.exports = __webpack_public_path__ + "assets/img/pasta_maker.261503b6.png";